import { forwardRef } from "react";

/**
 * CalendarButton - react-datepicker の customInput 用ボタン
 *
 * showDay=true のとき年月日（YYYYMMDD）、false のとき年月（YYYYMM）を表示する。
 * react-datepicker が onClick 等を注入するため forwardRef が必要。
 *
 * @param {string}   yyyyValue - 表示する日付文字列（YYYYMMDD または YYYYMM）
 * @param {boolean}  showDay   - true のとき「日」も表示する（デフォルト: false）
 * @param {function} onClick   - react-datepicker から注入されるクリックハンドラ
 */
const CalendarButton = forwardRef(({ yyyyValue, showDay = false, onClick }, ref) => (
  <button
    ref={ref}
    onClick={onClick}
    className="px-4 py-2 text-lg border border-gray-300 rounded shadow-sm active:shadow-none active:translate-y-px cursor-pointer"
  >
    <span>{yyyyValue.slice(0, 4)}</span>
    <span className="mx-1">年</span>
    <span>{yyyyValue.slice(4, 6)}</span>
    <span className="mx-1">月</span>
    {showDay && (
      <>
        <span>{yyyyValue.slice(6, 8)}</span>
        <span className="ml-1">日</span>
      </>
    )}
  </button>
));

export default CalendarButton;
